<script setup>
import { onMounted, ref, nextTick } from "vue";
import { useRoute } from "vue-router";

import Block from "@components/redesign/Block/Block.vue";
import SVGIcon from "@components/SVGIcon.vue";
import Spot from "@components/Spot/Spot.vue";
import SimpleModal from "@components/redesign/Modals/SimpleModal/SimpleModal.vue";

import { VueFinalModal } from "vue-final-modal";
const route = useRoute();

defineProps({
  customTitle: { type: Boolean, default: false },
  description: {
    type: String,
    default: "To learn more about Ways2Well services.",
  },
  pink: { type: Boolean, default: false },
});

const showAllenModal = ref(false);
const showModal = ref(false);
const showFrame = ref(false);
const video = ref(0);
const showTabSpawnModal = ref(false);

const handleMobileAllenChat = () => {
  showTabSpawnModal.value = false;
  window.open("/allen.html", "_blank");
};

const clickElementById = (id) => {
  nextTick(() => {
    const element = document.getElementById(id);
    if (element) {
      element.click();
    }
  });
};

onMounted(() => {
  if (route.hash === "#allen-gate-passed") {
    const isMobileUserAgent = /Mobi|Android/i.test(navigator.userAgent);
    const isMobileScreen = window.matchMedia("(max-width: 767px)").matches;
    if (isMobileUserAgent || isMobileScreen) {
      showTabSpawnModal.value = true;
    } else {
      showAllenModal.value = true;
    }
  } else if (route.hash === "#allen-live-chat") {
    clickElementById("allenCallButton");
  }

  video.value
    .play()
    .then()
    .catch(() => {
      showFrame.value = true;
    });
});

const handleHubspotAllenProxy = () => {
  // console.log("handleHubspotAllenProxy");
  nextTick(() => {
    // console.log("nexttick handleHubspotAllenProxy");
    const proxyButton = document.getElementById("hubspotAllenProxy");
    if (proxyButton) {
      // console.log("clicking hubspotAllenProxy", proxyButton);
      proxyButton.dispatchEvent(new MouseEvent("mouseup"));
    } else {
      // console.log("no hubspotAllenProxy", proxyButton);
    }
  });
};
</script>

<template>
  <Block>
    <div class="allen-container" :class="{ pink }">
      <Spot
        width="222"
        height="208"
        top="0"
        right="-20"
        blur="75"
        opacity="0.8"
        :color="pink ? 'magenta' : 'blue'"
        mobile
      />
      <Spot
        bottom="0"
        right="-236"
        rotate="180"
        :color="pink ? 'magenta' : 'blue'"
        mirror
        desktop
      />

      <div class="info">
        <SVGIcon class="stars" name="stars" width="56" height="56" />
        <h2 v-if="!customTitle" class="default-title">
          <span class="h2 text-brand">Connect live</span>
          with ALLEN
        </h2>
        <slot v-if="customTitle"></slot>
        <p class="description r-body-small-to-regular">{{ description }}</p>
      </div>
      <div class="allen">
        <video
          v-if="!showFrame"
          id="bgvid"
          ref="video"
          class="video"
          playsinline
          muted
          loop
          type="video/mp4"
        >
          <source
            src="https://w2w-web-media.imgix.net/videos/alien.mov"
            type="video/quicktime"
          />
          <source
            src="https://w2w-web-media.imgix.net/videos/alien.webm"
            type="video/webm"
          />
          <track src="" kind="captions" srclang="en" label="english_captions" />
        </video>

        <button
          id="allenCallButton"
          class="call-button button white bigger hs-cta-trigger-button hs-cta-trigger-button-170317803058"
          type="button"
          @click="handleHubspotAllenProxy"
        >
          <SVGIcon name="play-media" width="24" height="24" />
          Chat with Allen
        </button>
      </div>
    </div>

    <VueFinalModal
      v-if="showModal"
      v-model="showModal"
      classes="modal-container"
      content-class="modal-content"
      @click="showModal = false"
    >
      <div class="modal-content-wrapper">
        <a class="modal-close">
          <SVGIcon name="close-small" class="modal-close-icon" />
        </a>
        <iframe
          src="https://fast.wistia.net/embed/iframe/kthz50r7lb?videoFoam=true"
          class="video"
          allow="autoplay"
        ></iframe>
      </div>
    </VueFinalModal>

    <VueFinalModal
      v-if="showAllenModal"
      v-model="showAllenModal"
      classes="modal-container allen-modal"
      content-class="modal-content"
      @click="showAllenModal = false"
    >
      <div class="modal-content-wrapper">
        <a class="modal-close">
          <SVGIcon name="close-small" class="modal-close-icon" />
        </a>
        <div class="allen-wrapper">
          <iframe
            src="https://chat.portalis.ai/guest?orgId=327c2184-c657-4629-a012-96c0772b680f&slotId=bb8188bb-5867-45c0-9091-4461de1a31b2&autoCall=true"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            allow="camera;microphone;fullscreen;clipboard-write"
            referrerpolicy="origin"
          ></iframe>
        </div>
      </div>
    </VueFinalModal>
    <SimpleModal
      v-model="showTabSpawnModal"
      @closed="showTabSpawnModal = false"
    >
      <div class="tab-spawn-wrapper">
        <button
          class="button primary"
          type="button"
          @click="handleMobileAllenChat"
        >
          Click to Chat with Allen
        </button>
      </div>
    </SimpleModal>
  </Block>
</template>

<style src="./style.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
// .allen-modal.modal-container .modal-content-wrapper a.modal-close {
//   top: 0px;
//   right: -64px;
// }
.allen-wrapper {
  border-radius: 24px;
  overflow: hidden;
  height: 80vh;
  width: 100vw;
  @include media(">=phone") {
    width: 80vw;
  }
}

.tab-spawn-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}
</style>
